'use client';

import { useEffect, useState } from 'react';

export default function OfflineIndicator() {
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    // Check initial state
    if (!navigator.onLine) setOffline(true);

    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);

    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-warning/90 text-accent-foreground text-center text-xs font-medium py-1.5 px-4"
      style={{ paddingTop: 'calc(var(--safe-area-top, 0px) + 6px)' }}
    >
      You&apos;re offline — showing cached content
    </div>
  );
}
